import { writable } from "svelte/store";

// Persists the search-bar text as client state so it survives navigation
// (e.g. clicking into a post/image detail page) WITHOUT ever putting `?q=` in
// the URL. Keeping it out of the URL avoids the duplicate `/p/:id?q=` /
// `/m/:id?q=` pages that were wasting Google's crawl budget.
// sessionStorage scopes it to the current tab session.

const KEY = "nyanbooru-search-q";

function load() {
    try {
        return sessionStorage.getItem(KEY) || "";
    } catch {
        return "";
    }
}

export const searchQuery = writable(load());

searchQuery.subscribe((value) => {
    try {
        sessionStorage.setItem(KEY, value ?? "");
    } catch {
        // ignore (private mode / SSR)
    }
});
